import { ArrowUpRight } from "lucide-react";
import { Reveal } from "./Reveal";

const CHAPTERS = [
  {
    n: "01",
    title: "QUIÉNES SOMOS",
    body: "BC TRADERS nace de la experiencia real de Pol y Edgar dentro del mercado financiero. Años de operativa condensados en una metodología propia: lectura del precio, liquidez, estructura, manipulación y contexto institucional.",
  },
  {
    n: "02",
    title: "QUÉ NO SOMOS",
    body: "Ni estrategias con nombres complejos ni conceptos innecesarios. Nuestro objetivo es que entiendas cómo se mueve realmente el mercado, para construir una visión mucho más profesional, lógica y estructurada del trading.",
  },
  {
    n: "03",
    title: "QUÉ VAS A CONSTRUIR",
    body: "Una comprensión completa del mercado: interpretar el contexto en diferentes temporalidades, analizar paso a paso, ejecutar operaciones con confirmaciones reales y gestionar correctamente el riesgo.",
  },
  {
    n: "04",
    title: "EL OBJETIVO",
    body: "No es solo enseñarte entradas. Es ayudarte a operar con mayor lógica, disciplina y consistencia. Criterio propio, no señales ajenas.",
  },
];

const PILLARS = [
  "LECTURA DEL PRECIO",
  "LIQUIDEZ",
  "ESTRUCTURA",
  "MANIPULACIÓN",
  "CONTEXTO INSTITUCIONAL",
];

const MARKETS = ["EUR/USD", "GBP/USD", "NASDAQ", "S&P 500", "BITCOIN", "ORO"];

export const Manifesto = () => (
  <section data-testid="manifesto-section" className="relative px-6 py-28 sm:px-12 lg:px-20 lg:py-40">
    <Reveal>
      <p className="font-mono text-[11px] tracking-[0.4em] text-[#5EA2FF] sm:text-xs">
        {"// 01 — EL MANIFIESTO"}
      </p>
      <h2 className="mt-6 max-w-3xl font-display text-4xl font-bold uppercase leading-[1.02] tracking-tight text-white sm:text-5xl lg:text-6xl">
        No enseñamos estrategias.{" "}
        <span className="text-stroke-blue">Enseñamos a leer el mercado.</span>
      </h2>
    </Reveal>

    <div className="mt-20 grid grid-cols-1 gap-px overflow-hidden border border-[#5EA2FF]/15 bg-[#5EA2FF]/15 sm:grid-cols-2">
      {CHAPTERS.map((c, i) => (
        <Reveal key={c.n} delay={i * 0.08} className="bg-[#020A1A]">
          <div className="group h-full p-8 transition-colors duration-500 hover:bg-[#061226] lg:p-12">
            <span className="font-mono text-sm text-[#2F7DF6]">{c.n}</span>
            <h3 className="mt-4 font-display text-xl font-bold uppercase tracking-tight text-white sm:text-2xl">
              {c.title}
            </h3>
            <p className="mt-4 text-sm leading-relaxed text-[#7A90B8]">{c.body}</p>
          </div>
        </Reveal>
      ))}
    </div>

    <div className="mt-28">
      <Reveal>
        <p className="font-mono text-[11px] tracking-[0.4em] text-[#5EA2FF] sm:text-xs">
          {"// CÓMO LEEMOS EL MERCADO"}
        </p>
      </Reveal>
      <div className="mt-8 border-t border-[#5EA2FF]/15">
        {PILLARS.map((p, i) => (
          <Reveal key={p} delay={i * 0.06} y={20}>
            <div className="group flex cursor-default items-center justify-between border-b border-[#5EA2FF]/15 py-6 transition-all duration-500 hover:pl-4 sm:py-8">
              <div className="flex items-baseline gap-6">
                <span className="font-mono text-xs text-[#2F7DF6]">0{i + 1}</span>
                <span className="font-display text-2xl font-bold uppercase tracking-tight text-white/85 transition-colors duration-500 group-hover:text-[#5EA2FF] sm:text-4xl">
                  {p}
                </span>
              </div>
              <ArrowUpRight className="h-6 w-6 -translate-x-2 text-[#5EA2FF] opacity-0 transition-all duration-500 group-hover:translate-x-0 group-hover:opacity-100" />
            </div>
          </Reveal>
        ))}
      </div>
    </div>

    <Reveal delay={0.1} className="mt-20">
      <p className="font-mono text-[11px] tracking-[0.4em] text-[#7A90B8] sm:text-xs">
        BACKTESTING COMPLETO EN MERCADOS REALES
      </p>
      <div className="mt-6 flex flex-wrap gap-3">
        {MARKETS.map((m) => (
          <span
            key={m}
            data-testid={`market-chip-${m.toLowerCase().replace(/[^a-z]/g, "-")}`}
            className="border border-[#5EA2FF]/25 px-5 py-2.5 font-mono text-xs tracking-[0.2em] text-[#DCE8FF] transition-colors duration-300 hover:border-[#2F7DF6] hover:bg-[#2F7DF6]/10"
          >
            {m}
          </span>
        ))}
      </div>
    </Reveal>
  </section>
);
